// extracted by mini-css-extract-plugin
export default {"timeline":"Timeline_timeline__sfskD","column":"Timeline_column__2zWWJ","spacing":"Timeline_spacing__ZtyfO"};